module.exports = __webpack_public_path__ + "static/media/image (32).294ff10b.jpg";